const API_BASE = "";

const COMPANY_STORAGE_KEY = "paperclip.selectedCompanyId";

function resolveSelectedCompanyId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(COMPANY_STORAGE_KEY);
  } catch {
    return null;
  }
}

function rewriteCompanyScopedApiPath(url: string): string {
  if (!url.startsWith("/api/")) return url;
  if (url.startsWith("/api/companies/")) return url;

  const companyId = resolveSelectedCompanyId();
  if (!companyId) return url;

  const companyScopedPrefixes = [
    "/api/exchange/",
    "/api/ecosystem/",
    "/api/futures/",
  ];

  if (!companyScopedPrefixes.some((prefix) => url.startsWith(prefix))) return url;
  return url.replace("/api/", `/api/companies/${companyId}/`);
}

type FetchArg =
  | string
  | ({
      url: string;
      method?: string;
      body?: any;
      headers?: Record<string, string>;
    } & Record<string, any>);

export const $fetch = async <T = any>(
  arg: FetchArg,
  options?: RequestInit
): Promise<{ data: T | null; error: string | null }> => {
  try {
    const url = typeof arg === "string" ? arg : arg.url;
    const requestInit: RequestInit | undefined =
      typeof arg === "string"
        ? options
        : {
            ...options,
            method: arg.method ?? options?.method,
            headers: {
              ...(options?.headers || {}),
              ...(arg.headers || {}),
            },
            body:
              arg.body === undefined
                ? options?.body
                : typeof arg.body === "string"
                  ? arg.body
                  : JSON.stringify(arg.body),
          };

    const rawUrl = url.startsWith("http") || url.startsWith("/api") ? url : `${API_BASE}${url}`;
    const fullUrl = rawUrl.startsWith("http") ? rawUrl : rewriteCompanyScopedApiPath(rawUrl);
    const response = await fetch(fullUrl, requestInit);
    if (!response.ok) {
      return { data: null, error: `HTTP ${response.status}` };
    }
    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error instanceof Error ? error.message : "Unknown error" };
  }
};
